import { createMutableAction } from '@bimser/core';
import { IWebInterfaceAction } from '../../../../common/entities';
import * as ActionTypes from '../actionTypes';

export function updateRecentFiles(payload: IWebInterfaceAction) {
	return createMutableAction(ActionTypes.UPDATE_RECENT_FILES, payload);
}
